<template>
  <vs-col
    vs-w="2.8"
    class="p-0"
    vs-type="flex"
    vs-justify="flex-end"
    vs-align="center"
  >
    <SideBar
      :title="'Adicionar Servicos para ' + endereco.nome"
      @hide="modalOs = false"
      :active="modalOs"
      size="huger"
      @success="validacao == true ? submitForm() : verificarAgenda()"
      :textSucces="validacao == true ? 'Agendar Reforco' : 'Validar'"
      :visualizar="!buttonStatus"
    >
      <div
        class="w-full p-4 vs-con-loading__container"
        slot="body"
        id="cadastrar"
      >
        <vs-col vs-w="5" class="mr-10">
          <div class="w-full">
            <vs-col vs-w="12"> <Agenda class="m-4"></Agenda> </vs-col
            ><vs-col
              vs-w="12"
              vs-type="flex"
              vs-align="center"
              vs-justify="center"
            >
              <vs-button
                color="warning"
                :disabled="!$atividades.permissoes.includes(12)"
                @click="submitForm()"
                type="relief"
                >Agendar Sem Bloqueios</vs-button
              >
            </vs-col>
          </div>
        </vs-col>
        <vs-col vs-w="6.5">
          <vs-divider class="mt-0" border-style="dotted"
            >Informações gerais do serviço</vs-divider
          >
          <vs-row class="mt-4 mx-4 mb-0" vs-type="flex" vs-w="12">
            <vs-col vs-w="4">
              <vs-row>
                <div>
                  <label style="color: black; font-size: 13px"
                    >Tipo do Serviço</label
                  >
                </div>
              </vs-row>
              <div class="w-full">
                <el-select
                  style="width: 200px"
                  v-model="os.id_tipo"
                  clearable
                  v-validate="'required'"
                  name="tipo"
                  @change="handleChangeTipo()"
                  :popper-append-to-body="false"
                  filterable
                >
                  <el-option
                    v-for="tipo in tipos"
                    :key="tipo.id"
                    :label="tipo.id === 1 || tipo.id === 3 ? tipo.nome + ' (h.i)' : tipo.nome + ' (h.m)'"
                    :value="tipo.id"
                  ></el-option>
                </el-select>
              </div>
            </vs-col>
            <vs-col
              vs-w="5"
              class="ml-3"
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
            >
              <div class="w-full">
                <div style="display: flex; align-items: center; justify-content: space-between; width: 200px;">
                  <label style="color: black; font-size: 13px;">
                    {{ agendarPorTurno ? 'Turno' : 'Hora Marcada' }}
                  </label>
                  <vs-switch v-model="agendarPorTurno" @input="toggleAgendamento()">
                    <span slot="on"></span>
                    <span slot="off"></span>
                  </vs-switch>
                </div>
                <div v-if="agendarPorTurno">
                  <el-select
                    filterable
                    clearable
                    @change="removeValidacao()"
                    class="select-info"
                    placeholder="Selecione..."
                    v-model="os.id_turno"
                    name="turnos"
                    v-validate="'required'"
                    style="width: 200px"
                    :popper-append-to-body="false"
                  >
                    <el-option
                      v-for="turno in turnos"
                      class="select-info"
                      :value="turno.id"
                      :label="turno.nome"
                      :key="turno.id"
                    ></el-option>
                  </el-select>
                </div>
                <div v-else>
                  <vs-input
                    name="hora_marcada"
                    @change="removeValidacao()"
                    v-model="os.hora_marcada"
                    v-validate="'required'"
                    v-mask="'##:00'"
                    max="24"
                    type="datetime"
                    placeholder="00:00"
                    class="inputx"
                    style="max-width: 200px;"
                  />
                </div>
              </div>
            </vs-col>
          </vs-row>

          <vs-row
            class="mt-2 mb-0"
            vs-type="flex"
            vs-justify="flex-start"
            vs-w="12"
          >
            <vs-col
              vs-w="2.5"
              class="mx-3"
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
            >
              <div class="w-full">
                <vs-input
                  label="Tecnicos"
                  name="tecnicos"
                  v-validate="'required'"
                  size="small"
                  v-model="os.tecnicos_exec"
                  @change="removeValidacao()"
                  :danger="erros.tecnicos_exec"
                  danger-text="Mínimo 1"
                  min="1"
                  class="inputx w-full"
                  type="number"
                />
              </div>
            </vs-col>
            <vs-col
              vs-w="2.5"
              class="mx-3"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
            >
              <div class="w-full">
                <vs-input
                  label="Horas"
                  size="small"
                  name="hora"
                  v-validate="'required'"
                  v-model="os.horas_exec"
                  @change="removeValidacao()"
                  :danger="erros.horas_exec"
                  danger-text="Mínimo 1"
                  min="1"
                  type="number"
                  class="inputx w-full"
                />
              </div>
            </vs-col>
            <vs-col
              vs-w="2.5"
              class="mx-3"
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
            >
              <div class="w-full">
                <vs-input
                  class="inputx w-full"
                  color="success"
                  :v-validate="'required|numeric|min_value:' + minCarros"
                  label="Carros."
                  :min="minCarros"
                  :disabled="disabledCarros"
                  size="small"
                  type="number"
                  v-model="os.carros"
                  name="carros"
                  @change="validarCarros()"
                />
              </div>
            </vs-col>
          </vs-row>
          <div id="head_modal_reforco" class="vs-con-loading__container">
            <vs-divider border-style="dotted">Data do serviço</vs-divider>
            <vs-row class="ml-5">
              <vs-col vs-w="12" class="mb-5">
                <div class="date-with-badge">
                  <vs-input
                    label="Data do serviço"
                    type="date"
                    color="dark"
                    @change="removeValidacao()"
                    name="data"
                    v-validate="'required'"
                    v-model="os.data_competencia"
                  />
                  <div class="status-badge-wrapper date-badge-inline">
                    <div v-if="statusValidacao === null" class="status-badge badge-aguardando">
                      <i class="material-icons badge-icon">hourglass_empty</i>
                      <span class="badge-text">Aguardando validação</span>
                    </div>
                    <div v-else-if="statusValidacao === 'indisponivel'" class="status-badge badge-indisponivel">
                      <i class="material-icons badge-icon">close</i>
                      <span class="badge-text">Não há disponibilidade</span>
                      <button
                        v-if="servico.historicoFalhas && servico.historicoFalhas.length > 0"
                        class="badge-history-btn"
                        @click="popupHistoricoAtivo = true"
                      >
                        <i class="material-icons" style="font-size: 13px;">history</i>
                        Dias
                      </button>
                    </div>
                    <div v-else-if="statusValidacao === 'proximo'" class="status-badge badge-proximo">
                      <i class="material-icons badge-icon">warning</i>
                      <span class="badge-text">Data mais próxima: {{ dataProxima }}</span>
                      <button
                        v-if="servico.historicoFalhas && servico.historicoFalhas.length > 0"
                        class="badge-history-btn"
                        @click="popupHistoricoAtivo = true"
                      >
                        <i class="material-icons" style="font-size: 13px;">history</i>
                        Dias
                      </button>
                    </div>
                    <div v-else-if="statusValidacao === 'disponivel'" class="status-badge badge-disponivel">
                      <i class="material-icons badge-icon">check_circle</i>
                      <span class="badge-text">Disponível</span>
                    </div>
                  </div>
                </div>
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
      </div>
    </SideBar>

    <ModalHistoricoBuscaForca
      :ativo.sync="popupHistoricoAtivo"
      :historico="servico.historicoFalhas || []"
      :data-selecionada="servico.data"
      :disponivel="servico.disponivel"
    />
  </vs-col>
</template>
<script>
import components from "@/components/default/exports.js"
import Agenda from "../../../agenda/Agenda.vue"
import ModalHistoricoBuscaForca from "./modalHistoricoBuscaForca.vue"
export default {
  props: {
    cliente: { required: true },
    contrato: { required: true },
    endereco: { required: true },
  },
  data () {
    return {
      agendarPorHora: false,
      agendarPorTurno: true,
      minCarros: 0,
      buttonStatus: true,
      diaSelect: [1, 2, 3, 4, 5, 6, 7],
      validacao: false,
      turnos: [
        { id: 1, nome: "Manha" },
        { id: 2, nome: "Almoco" },
        { id: 3, nome: "Tarde" },
        { id: 4, nome: "Noite" },
        { id: 5, nome: "Madrugada" },
      ],
      tipos: [],
      modalOs: false,
      popupHistoricoAtivo: false,
      statusValidacao: null,
      dataProxima: null,
      servico: { status: "Aguardando validação", obs: "Aguardando validação", historicoFalhas: [] },
      os: {
        id_turno: null,
        horas_exec: 1,
        id_tipo: null,
        tecnicos_exec: 1,
        hora_marcada: null,
        data_competencia: null,
        carros: 0,
      },
      erros: {
        tecnicos_exec: false,
        horas_exec: false,
      },
    }
  },
  computed: {
    disabledCarros() {
      return !this.os.id_tipo;
    },
    podeZerarForca() {
      return (
        this.$atividades &&
        Array.isArray(this.$atividades.permissoes) &&
        this.$atividades.permissoes.includes(27)
      );
    },
  },
  methods: {
    toggleAgendamento() {
      this.removeValidacao();
    },
    formatarData(data) {
      if (!data) return '';
      const parts = data.split('-');
      return parts.length === 3 ? `${parts[2]}/${parts[1]}/${parts[0]}` : data;
    },
    async verificarAgenda () {
      const isTurnoValido = this.agendarPorTurno && this.os.id_turno !== null && this.os.id_turno !== '';
      const isHoraMarcadaValida = !this.agendarPorTurno && this.os.hora_marcada !== null && this.os.hora_marcada !== '';

      if (
        (isTurnoValido || isHoraMarcadaValida) &&
        this.os.id_tipo != null && this.os.id_tipo !== '' &&
        this.os.tecnicos_exec != null && this.os.tecnicos_exec !== '' &&
        this.os.horas_exec != null && this.os.horas_exec !== '' &&
        this.os.data_competencia != null && this.os.data_competencia !== ''
      ) {
        this.erros.tecnicos_exec = !this.podeZerarForca && Number(this.os.tecnicos_exec) < 1
        this.erros.horas_exec = !this.podeZerarForca && Number(this.os.horas_exec) < 1
        if (this.erros.tecnicos_exec || this.erros.horas_exec) {
          this.$vs.notify({
            title: "Erro",
            text: "Técnicos e Horas precisam ser no mínimo 1",
            color: "danger",
          })
          return
        }
        this.buttonStatus = false
        this.validacao = null
        const dataOriginal = this.os.data_competencia
        this.$vs.loading({ container: "#head_modal_reforco", scale: 0.9 })
        let horasNecessarias = this.os.horas_exec * this.os.tecnicos_exec
        try {
          let date = this.$formartData.dataHoje()
          this.servico = await this.$http.post("verificarForca", {
            data: this.os.data_competencia,
            id_turno: this.agendarPorTurno ? this.os.id_turno : null,
            horaMarcada: !this.agendarPorTurno ? this.os.hora_marcada : null,
            horas_exec: this.os.horas_exec,
            tecnicos_exec: this.os.tecnicos_exec,
            dias: this.diaSelect,
            inicial: this.os.id_tipo == 1 || this.os.id_tipo == 3,
            carros: parseInt(this.os.carros) || 0,
            hoje: date,
            periodoManutencao: this.contrato.periodo_manutencao,
            datas: [],
          })
          if (this.servico.disponivel == 1) {
            if (this.servico.data === dataOriginal) {
              this.statusValidacao = 'disponivel'
            } else {
              this.statusValidacao = 'proximo'
              this.dataProxima = this.formatarData(this.servico.data)
            }
            this.os.data_competencia = this.servico.data
            this.servico.color = "success"
          } else {
            this.servico.ultimaData = this.servico.data
            this.statusValidacao = 'indisponivel'
            this.validacao = false
            this.servico.color = "danger"
          }
          if (this.servico.historicoFalhas && this.servico.historicoFalhas.length > 0) {
            this.popupHistoricoAtivo = true
          }
        } catch (err) {
          const error = this.$httpErrors(err)
          this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
        }
        this.$vs.loading.close("#head_modal_reforco > .con-vs-loading")
        this.verificarServicos()
        this.buttonStatus = true
      } else {
        this.$vs.notify({
          title: "Erro",
          text: "Preencha os campos",
          color: "danger",
        })
        this.buttonStatus = true
      }
    },
    async verificarServicos () {
      if (this.validacao != false) {
        this.validacao = true
      }
    },
    async removeValidacao () {
      this.validacao = false
      this.statusValidacao = null
      this.dataProxima = null
      this.servico = { status: "Aguardando validação", obs: "Aguardando validação", historicoFalhas: [] }
      this.popupHistoricoAtivo = false
      this.erros.tecnicos_exec = false
      this.erros.horas_exec = false
    },
    handleChangeTipo () {
      this.removeValidacao();
      this.minCarros = 0;
      
      if (!this.os.id_tipo) {
        this.os.carros = 0;
        return;
      }

      if (this.os.id_tipo === 4 || this.os.id_tipo === 5) {
        // Livre de restrição
      } else {
        const tipoSelecionado = this.tipos.find(t => t.id === this.os.id_tipo);
        if (tipoSelecionado) {
          const nome = tipoSelecionado.nome.toLowerCase();
          const isInicial = nome.includes('inicial');
          const isComplemento = nome.includes('complemento');
          const isReforco = nome.includes('reforço') || nome.includes('reforco');

          if (isInicial) {
            const carrosInicial = parseInt(this.contrato.carros_inicial) || 0;
            this.os.carros = carrosInicial;
            if (carrosInicial > 0) {
              this.minCarros = 1;
            }
          } else if (!isInicial && !isComplemento && !isReforco) {
            const carrosContrato = parseInt(this.contrato.carros) || 0;
            this.os.carros = carrosContrato;
            if (carrosContrato > 0) {
              this.minCarros = 1;
            }
          }
        }
      }
    },
    validarCarros () {
      this.removeValidacao();
      const valor = parseInt(this.os.carros);

      if (!this.os.id_tipo) return;

      // IDs 4 e 5 são livres, sem restrição
      if (this.os.id_tipo === 4 || this.os.id_tipo === 5) return;

      const tipoSelecionado = this.tipos.find(t => t.id === this.os.id_tipo);
      if (!tipoSelecionado) return;

      const nome = tipoSelecionado.nome.toLowerCase();
      const isInicial = nome.includes('inicial');
      const isComplemento = nome.includes('complemento');
      const isReforco = nome.includes('reforço') || nome.includes('reforco');

      if (isComplemento || isReforco) return;

      if (isInicial) {
        const carrosInicial = parseInt(this.contrato.carros_inicial) || 0;
        if (carrosInicial > 0 && valor < 1) {
          this.os.carros = carrosInicial;
          this.$vs.notify({
            title: 'Valor inválido para Carros',
            text: `O contrato exige ao menos 1 carro para o serviço Inicial (contrato: ${carrosInicial}). Não é permitido zerar este campo.`,
            color: 'warning',
            time: 5000,
          });
        }
      } else {
        // qualquer outro tipo (diferente de inicial, complemento e reforço)
        const carrosContrato = parseInt(this.contrato.carros) || 0;
        if (carrosContrato > 0 && valor < 1) {
          this.os.carros = carrosContrato;
          this.$vs.notify({
            title: 'Valor inválido para Carros',
            text: `O contrato exige ao menos 1 carro para este tipo de serviço (contrato: ${carrosContrato}). Não é permitido zerar este campo.`,
            color: 'warning',
            time: 5000,
          });
        }
      }
    },
    async submitForm () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.cadastrar()
          } else {
            this.$vs.notify({
              title: "Preencha todos os campos",
              text: "Os campos não devem ser vazios!",
              color: "danger",
            })
            reject("error")
          }
        })
      })
    },
    async cadastrar () {
      await this.$vs.loading({ container: "#cadastrar", scale: 0.6 })
      this.os.id_cliente = this.contrato.id_cliente
      this.os.id_contrato = this.contrato.id
      this.os.id_endereco = this.endereco.id_endereco
      this.os.obs = this.contrato.obs_tecnica
      
      if (this.agendarPorTurno) {
        this.os.hora_marcada = null;
      } else {
        this.os.id_turno = null;
      }
      
      try {
        const res = await this.$http.post("cadastrarNovaOs", this.os)
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "cadastrar",
          setor: "comercial",
          ip: window.localStorage.getItem("ip"),
          texto: "Cadastro da OS N°" + res.id,
        }
        await this.$logger(logData)
        this.$vs.notify({
          title: "",
          text: "Reforco cadastrado com successo",
          color: "success",
        })
      } catch (err) {
        const error = this.$httpErrors(err)
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      }
      this.$emit("update")
      await this.$vs.loading.close("#cadastrar > .con-vs-loading")
      this.modalOs = false
    },
    async getTipos () {
      try {
        this.tipos = await this.$http.get("os_tipos")
      } catch (err) {
        const error = this.$httpErrors(err)
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        }
      }
    },
  },
  async mounted () {
    this.modalOs = true
    this.agendarPorTurno = true;
    await this.getTipos()
  },
  components: {
    ...components,
    Agenda,
    ModalHistoricoBuscaForca,
  },
};
</script>
<style scoped>
.status-badge-wrapper {
  display: flex;
  align-items: center;
  margin-top: 18px;
}
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.badge-icon {
  font-size: 16px !important;
}
.badge-text {
  font-size: 12px;
}
.badge-aguardando {
  background-color: #fef3c7;
  color: #78350f;
}
.badge-indisponivel {
  background-color: #fee2e2;
  color: #7f1d1d;
}
.badge-proximo {
  background-color: #fed7aa;
  color: #7c2d12;
}
.badge-disponivel {
  background-color: #bbf7d0;
  color: #14532d;
}
.badge-history-btn {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-left: 6px;
  padding: 2px 8px;
  border: none;
  border-radius: 12px;
  background: rgba(0,0,0,0.15);
  color: inherit;
  font-size: 11px;
  cursor: pointer;
  white-space: nowrap;
  font-family: inherit;
}
.badge-history-btn:hover {
  background: rgba(0,0,0,0.25);
}
.date-with-badge {
  display: flex;
  align-items: flex-end;
  gap: 12px;
}
.date-badge-inline {
  flex-shrink: 0;
  margin-top: 0;
  padding-bottom: 4px;
}
</style>
